import React from "react";
import { User } from "~/common/Store/models/User";
interface Props {
  user: User;
  stockCount: number;
  hasDropShip: boolean;
}
const StockCount = ({
  user,
  stockCount,
  hasDropShip
}: Props) => {
  return <>
      {user.registered && user.platinum.enabled && (hasDropShip || stockCount > 0) && <div className="product__stat mt-2" data-testid="stock-count">
            <span className="product__stat-title font-semibold">Stock:</span>
            <span className="product__stat-desc">
              {hasDropShip ? "Ships From Manufacturer" : stockCount}
            </span>
          </div>}
    </>;
};
export default StockCount;